module.exports = __webpack_public_path__ + "static/media/16.88d8b4df.jpg";